
import { PrivilegeRules } from "@/components/compliance/PrivilegeRules";
import SecurePageAccess from "@/components/SecurePageAccess";

export default function CompliancePage() {
  return (
    <SecurePageAccess resourceName="compliance" requiredPermission="view">
      <div className="space-y-8 p-8">
        <PrivilegeRules />
      </div>
    </SecurePageAccess>
  );
}
